import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";


export default function AutocOneFieldUsemap(props: any) {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {name, mapData, trgFieldObj, setTrgFieldObj, setUsemapRedirectURL} = props

    let val = trgFieldObj.fieldName || ''

    let queryData: any = {...mapData, fieldType: trgFieldObj.fieldType}

    const [valuesArr, setValuesArr] = useState<any[]>(val ? [val] : [''])

    const [isInputFieldRed, setIsInputFieldRed] = useState<boolean>(true)

    return (
        <Autocomplete
            key={1}
            value={val}
            onChange={(event, newValue) => {

                if (newValue) {
                    setTrgFieldObj((prevState: any) => {
                        return {
                            ...prevState,
                            fieldName: newValue.fieldName,
                            fieldUID: newValue.fieldUID,
                            fieldID: newValue.fieldID
                        }
                    })

                    // validating selected target field -- checking if such a mapping already exists
                    fetch(`${serverIP}/fieldusemapvalidate/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify({projUID: mapData.projUID, fieldUID: newValue.fieldUID}),
                    }).then(res => res.json())
                        .then(data => {
                            if (data.exists) {
                                setUsemapRedirectURL(`../map/${newValue.fieldUID}`)
                            }
                        })

                } else {
                    setTrgFieldObj((prevState: any) => {
                        return {...prevState, fieldName: '', fieldUID: '', fieldID: ''}
                    })

                    setIsInputFieldRed(true)
                }
            }}

            isOptionEqualToValue={(option, value) => option.value === value.value}

            onInputChange={(event, newValue) => {
                setIsInputFieldRed(false)

                if (newValue && newValue.length >= 1) {

                    queryData['qString'] = newValue

                    fetch(`${serverIP}/fieldusemapgettrgdata/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify(queryData),
                    }).then(res => res.json())
                        .then((data) => {
                            setValuesArr(data)
                        })
                } else {
                    setValuesArr([])
                }
            }}

            disablePortal
            autoHighlight
            forcePopupIcon={false}
            size="small"
            id="combo-box-demo"
            options={valuesArr}
            sx={{width: 'auto'}}
            ListboxProps={
                {
                    style: {
                        fontSize: '0.8rem',
                        fontFamily: "'Inter', sans-serif",
                        color: 'black'
                    }
                }}

            renderInput={(params) =>
                <TextField
                    {...params}
                    label=""
                    style={{backgroundColor: 'white'}}
                    error={isInputFieldRed}
                    // InputProps={{
                    //     style: {height: 30}
                    // }}
                />}
        />
    );
}
